import QuillEditor from "../text_editor";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom";
import { addShiftJob } from "../../slice/workerShiftAddJobSlice";
import { getJobCategories } from "../../slice/workerJobSlice";

import {
    Stepper,
    Step,
    StepLabel,
    Button,
    TextField,
    FormControl,
    FormLabel,
    InputLabel,
    Select,
    MenuItem,
    RadioGroup,
    FormControlLabel,
    Radio,
    Paper,
    Grid,
    Typography,
    Divider
} from "@mui/material";

const states = [
    { id: 1, code: 'AL', name: 'Alabama' },
    { id: 2, code: 'AK', name: 'Alaska' },
    { id: 3, code: 'AZ', name: 'Arizona' },
    { id: 4, code: 'AR', name: 'Arkansas' },
    { id: 5, code: 'CA', name: 'California' },
    { id: 6, code: 'CO', name: 'Colorado' },
    { id: 7, code: 'CT', name: 'Connecticut' },
    { id: 8, code: 'DE', name: 'Delaware' },
    { id: 9, code: 'FL', name: 'Florida' },
    { id: 10, code: 'GA', name: 'Georgia' },
    { id: 11, code: 'HI', name: 'Hawaii' },
    { id: 12, code: 'ID', name: 'Idaho' },
    { id: 13, code: 'IL', name: 'Illinois' },
    { id: 14, code: 'IN', name: 'Indiana' },
    { id: 15, code: 'IA', name: 'Iowa' },
    { id: 16, code: 'KS', name: 'Kansas' },
    { id: 17, code: 'KY', name: 'Kentucky' },
    { id: 18, code: 'LA', name: 'Louisiana' },
    { id: 19, code: 'ME', name: 'Maine' },
    { id: 20, code: 'MD', name: 'Maryland' },
    { id: 21, code: 'MA', name: 'Massachusetts' },
    { id: 22, code: 'MI', name: 'Michigan' },
    { id: 23, code: 'MN', name: 'Minnesota' },
    { id: 24, code: 'MS', name: 'Mississippi' },
    { id: 25, code: 'MO', name: 'Missouri' },
    { id: 26, code: 'MT', name: 'Montana' },
    { id: 27, code: 'NE', name: 'Nebraska' },
    { id: 28, code: 'NV', name: 'Nevada' },
    { id: 29, code: 'NH', name: 'New Hampshire' },
    { id: 30, code: 'NJ', name: 'New Jersey' },
    { id: 31, code: 'NM', name: 'New Mexico' },
    { id: 32, code: 'NY', name: 'New York' },
    { id: 33, code: 'NC', name: 'North Carolina' },
    { id: 34, code: 'ND', name: 'North Dakota' },
    { id: 35, code: 'OH', name: 'Ohio' },
    { id: 36, code: 'OK', name: 'Oklahoma' },
    { id: 37, code: 'OR', name: 'Oregon' },
    { id: 38, code: 'PA', name: 'Pennsylvania' },
    { id: 39, code: 'RI', name: 'Rhode Island' },
    { id: 40, code: 'SC', name: 'South Carolina' },
    { id: 41, code: 'SD', name: 'South Dakota' },
    { id: 42, code: 'TN', name: 'Tennessee' },
    { id: 43, code: 'TX', name: 'Texas' },
    { id: 44, code: 'UT', name: 'Utah' },
    { id: 45, code: 'VT', name: 'Vermont' },
    { id: 46, code: 'VA', name: 'Virginia' },
    { id: 47, code: 'WA', name: 'Washington' },
    { id: 48, code: 'WV', name: 'West Virginia' },
    { id: 49, code: 'WI', name: 'Wisconsin' },
    { id: 50, code: 'WY', name: 'Wyoming' },
];

const WorkerAddJobShift = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loading } = useSelector((state) => state.workerShiftJob);
    const { jobCategories } = useSelector((state) => state.workerJob);

    const token = localStorage.getItem("token");

    const [activeStep, setActiveStep] = useState(0);

    const steps = [
        "Role & Category",
        "Location & Shift Timing",
        "Salary & Requirements",
        "Review & Submit",
    ];

    const [form, setForm] = useState({
        title: "",
        role_type: "",
        job_type: "",
        categories_id: "",
        experience_level: "",
        city: "",
        state: "",
        country: "US",
        start_date: "",
        end_date: "",
        start_time: "",
        end_time: "",
        salary_min: "",
        salary_max: "",
        currency: "USD",
        ratio: "",
        from_age: "",
        to_age: "",
        description: "",
    });

    /* ---------------- HANDLERS ---------------- */

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleRoleChange = (e) => {
        const role = e.target.value;
        const label =
            role === "5" ? "Teachers & Assistants" : "Support Staffing Roles";

        dispatch(getJobCategories(role));

        setForm((prev) => ({
            ...prev,
            role_type: role,
            title: `Job For ${label}`,
            categories_id: "",
        }));
    };
    const validateStep = (step) => {
        switch (step) {
            case 0:
                if (!form.role_type) return toast.error("Select role type"), false;
                if (!form.title) return toast.error("Enter title"), false;
                if (!form.categories_id)
                    return toast.error("Select category"), false;
                return true;

            case 1:
                if (!form.city) return toast.error("Enter city"), false;
                if (!form.state) return toast.error("Select state"), false;
                if (!form.start_date)
                    return toast.error("Select start date"), false;
                if (!form.end_date) return toast.error("Select end date"), false;
                if (!form.start_time)
                    return toast.error("Select start time"), false;
                if (!form.end_time)
                    return toast.error("Select end time"), false;
                return true;

            case 2:
                if (!form.salary_min)
                    return toast.error("Enter minimum salary"), false;
                if (!form.salary_max)
                    return toast.error("Enter maximum salary"), false;
                if (!form.ratio)
                    return toast.error("Select salary ratio"), false;
                if (!form.description)
                    return toast.error("Enter description"), false;
                return true;

            default:
                return true;
        }
    };

    const handleNext = () => {
        if (!validateStep(activeStep)) return;
        setActiveStep((prev) => prev + 1);
    };

    const handleBack = () => {
        setActiveStep((prev) => prev - 1);
    };

    const handleSubmit = () => {
        const payload = {
            ...form,
            classroom_age_group:
                form.from_age && form.to_age
                    ? `${form.from_age}-${form.to_age}`
                    : "",
        };

        delete payload.from_age;
        delete payload.to_age;
        
        dispatch(addShiftJob({ token, payload }))
            .unwrap()
            .then(() => {
                toast.success("Shift Job Added Successfully!");
                navigate("/panel/shift-jobs");
            })
            .catch(() => toast.error("Failed to add shift job"));
    };

    return (
        <>
            <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                <div className="ps-2 ps-lg-4">
                    <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
                        Add Shift Request
                    </h4>

                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>

                    {/* ================= STEP 0 ================= */}
                    {activeStep === 0 && (
                        <>
                            <FormControl
                                margin="normal"
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                }}
                            >
                                <label className="form-label text-primary font-weight-semibold required me-3 mb-0">
                                    I would like to create shift request for:
                                </label>

                                <RadioGroup
                                    row
                                    value={form.role_type}
                                    onChange={handleRoleChange}
                                >
                                    <FormControlLabel
                                        value="5"
                                        control={<Radio />}
                                        label="Teachers & Assistants"
                                        className="me-3"
                                    />
                                    <FormControlLabel
                                        value="6"
                                        control={<Radio />}
                                        label="Support Staffing Roles"
                                    />
                                </RadioGroup>
                            </FormControl>


                            {form.role_type && (
                                <>
                                    <TextField
                                        fullWidth
                                        label="Title"
                                        name="title"
                                        value={form.title}
                                        onChange={handleChange}
                                        margin="normal"
                                    />

                                    <FormControl fullWidth margin="normal">
                                        <InputLabel>Category</InputLabel>
                                        <Select
                                            name="categories_id"
                                            value={form.categories_id}
                                            onChange={handleChange}
                                            label="Category"
                                        >
                                            <MenuItem value="">-- Select --</MenuItem>
                                            {jobCategories?.map((cat) => (
                                                <MenuItem key={cat.id} value={cat.id}>
                                                    {cat.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                </>
                            )}
                        </>
                    )}

                    {/* ================= STEP 1 ================= */}
                    {activeStep === 1 && (
                        <>
                            <TextField
                                label="City"
                                name="city"
                                value={form.city}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />

                            <FormControl fullWidth margin="normal" variant="outlined">
                                <InputLabel id="state-label">State</InputLabel>
                                <Select
                                    name="state"
                                    label="State"
                                    labelId="state-label"
                                    value={form.state}
                                    onChange={handleChange}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem value="">-- Select State --</MenuItem>
                                    {states.map((s) => (
                                        <MenuItem key={s.id || s.code} value={s.code}>
                                            {s.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>



                            <Grid container spacing={2} mt={2}>
                                <Grid item xs={6}>
                                    <TextField
                                        type="date"
                                        label="From Date"
                                        name="start_date"
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        value={form.start_date}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        type="date"
                                        label="To Date"
                                        name="end_date"
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        value={form.end_date}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        type="time"
                                        label="Start Time"
                                        name="start_time"
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        value={form.start_time}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        type="time"
                                        label="End Time"
                                        name="end_time"
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        value={form.end_time}
                                        onChange={handleChange}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    )}

                    {/* ================= STEP 2 ================= */}
                    {activeStep === 2 && (
                        <>
                            <TextField
                                label="Salary Min"
                                name="salary_min"
                                value={form.salary_min}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                            <TextField
                                label="Salary Max"
                                name="salary_max"
                                value={form.salary_max}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />


                            <div className="d-flex gap-3 mt-2">
                                <FormControl variant="outlined" sx={{ minWidth: 120 }}>
                                    <InputLabel>Currency</InputLabel>
                                    <Select name="currency" value={form.currency} onChange={handleChange} label="Currency">
                                        <MenuItem value="USD">USD</MenuItem>
                                        <MenuItem value="EUR">EUR</MenuItem>
                                        <MenuItem value="GBP">GBP</MenuItem>
                                    </Select>
                                </FormControl>

                                <FormControl variant="outlined" sx={{ minWidth: 120 }}>
                                    <InputLabel>Ratio</InputLabel>
                                    <Select name="ratio" value={form.ratio} onChange={handleChange} label="Ratio">
                                        <MenuItem value="yearly">Per Year</MenuItem>
                                        <MenuItem value="monthly">Per Month</MenuItem>
                                        <MenuItem value="weekly">Per Week</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>

                            <Grid container spacing={2} mt={2}>
                                <Grid item xs={6}>
                                    <TextField
                                        label="From Age"
                                        name="from_age"
                                        value={form.from_age}
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        label="To Age"
                                        name="to_age"
                                        value={form.to_age}
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                            <FormControl fullWidth margin="normal">
                                <label className="form-label text-primary mb-1 font-weight-semibold">Provide some Details of Shift Job</label>
                                <QuillEditor
                                    onChange={(val) =>
                                        setForm((prev) => ({ ...prev, description: val }))
                                    }
                                />
                            </FormControl>
                        </>
                    )}

                    {/* ================= STEP 3 ================= */}
                    {activeStep === 3 && (
                        <Paper elevation={3} sx={{ p: 4, mt: 3, borderRadius: 3 }}>
                            <Typography variant="h5" gutterBottom fontWeight="bold" color="primary">
                                Review Shift Job
                            </Typography>
                            <Divider sx={{ mb: 3 }} />

                            <Grid container spacing={2}>
                                {/* Left Column */}
                                <Grid item xs={12} sm={6}>
                                    <Typography mb={1}><strong>Role:</strong> {form.role_type === "5" ? "Teachers & Assistants" : "Support Staffing Roles"}</Typography>
                                    <Typography mb={1}><strong>Job Title:</strong> {form.title}</Typography>
                                    <Typography mb={1}><strong>Category:</strong> {jobCategories?.find(c => c.id === form.categories_id)?.name || ""}</Typography>
                                </Grid>

                                {/* Right Column */}
                                <Grid item xs={12} sm={6}>
                                    <Typography mb={1}><strong>City:</strong> {form.city}</Typography>
                                    <Typography mb={1}><strong>State:</strong> {states.find(s => s.code === form.state)?.name || ""}</Typography>
                                    <Typography mb={1}><strong>Salary:</strong> {form.salary_min} - {form.salary_max} {form.currency}</Typography>
                                    <Typography mb={1}><strong>From Date:</strong> {form.start_date}</Typography>
                                    <Typography mb={1}><strong>To Date:</strong> {form.end_date}</Typography>
                                </Grid>

                                {/* Additional Info Row */}
                                <Grid container item xs={12} spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Typography mb={1}><strong>Start Time:</strong> {form.start_time}</Typography>
                                        <Typography mb={1}><strong>End Time:</strong> {form.end_time}</Typography>
                                        <Typography mb={1}><strong>Salary Ratio:</strong> {form.ratio}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography mb={1}><strong>Age Range:</strong> {form.from_age} - {form.to_age} years</Typography>
                                    </Grid>
                                </Grid>

                                {/* Description (Full width) */}
                                <Grid item xs={12}>
                                    <Typography mb={1}><strong>Description:</strong></Typography>
                                    <Paper
                                        variant="outlined"
                                        sx={{ p: 1, mt: 1, backgroundColor: "#f9f9f9", borderRadius: 1, whiteSpace: 'pre-wrap' }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: form.description }} />
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Paper>
                    )}

                    {/* ================= ACTIONS ================= */}
                    <div className="mt-4 d-flex justify-content-between">
                        <Button disabled={activeStep === 0} onClick={handleBack}>
                            Back
                        </Button>

                        {activeStep === steps.length - 1 ? (
                            <Button variant="contained" onClick={handleSubmit} disabled={loading}>
                                {loading ? "Saving..." : "Submit Shift Job"}
                            </Button>
                        ) : (
                            <Button variant="contained" onClick={handleNext}>
                                Next
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default WorkerAddJobShift;